import { type Component } from "vue";
import { type RouteRecordRaw } from "vue-router";

export function aiEmployeeRoutes(MainLayout: Component): RouteRecordRaw {
  return {
    path: "/aiemployee",
    component: MainLayout,
    children: [
      {
        path: "",
        component: () =>
          import("core-fe-lib/components-shadcn/layouts/PassthroughLayout.vue"),
        children: [
          {
            path: "dashboard",
            name: "aiemployee-dashboard",
            component: () =>
              import("@/modules/aiemployee/pages/DashboardPage.vue"),
            meta: { requiresAuth: true },
          },
          // Per-employee tabbed workspace. The workspace owns the header
          // (avatar + name + role + status) and renders a tab bar above
          // <router-view>. Only four tabs are mounted: Home (default),
          // Insights, Cost, Runs.
          {
            path: "employees/:id",
            component: () =>
              import("@/modules/aiemployee/pages/EmployeeWorkspacePage.vue"),
            meta: { requiresAuth: true },
            children: [
              {
                path: "",
                name: "aiemployee-detail",
                component: () =>
                  import("@/modules/aiemployee/pages/EmployeeHomePage.vue"),
              },
              {
                path: "insights",
                name: "aiemployee-detail-insights",
                component: () =>
                  import("@/modules/aiemployee/pages/EmployeeInsightsTab.vue"),
              },
              {
                path: "cost",
                name: "aiemployee-detail-cost",
                component: () =>
                  import("@/modules/aiemployee/pages/EmployeeCostTab.vue"),
              },
              {
                path: "runs",
                name: "aiemployee-detail-runs",
                component: () =>
                  import("@/modules/aiemployee/pages/EmployeeRunsTab.vue"),
              },
            ],
          },
          // Runs list + detail are NOT registered here: the LMS editor space
          // owns them at /lms/admin/runs with the SAME route names
          // (aiemployee-runs-list / aiemployee-run-detail). Re-declaring them
          // would collide — Vue Router drops the earlier route on a duplicate
          // name, 404-ing /lms/admin/runs. The name-based deep-links from the
          // Home / Runs / Insights tabs resolve to the LMS routes instead.
        ],
      },
    ],
  };
}
